import { createSlice } from "@reduxjs/toolkit";
import {
  viewHouseCategory,
  deleteHouseCategory,
  singleHouseCategory,
  updateHouseCategory,
  registerHouseCategory,
} from "../actions/houseCategoryAction";

const HouseCategorySlice = createSlice({
  name: "houseCategory",
  initialState: {
    houseCategory: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(viewHouseCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewHouseCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.houseCategory = action.payload;
      })
      .addCase(viewHouseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(updateHouseCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHouseCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.houseCategory = action.payload;
      })
      .addCase(updateHouseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteHouseCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteHouseCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.houseCategory = action.payload;
      })
      .addCase(deleteHouseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleHouseCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleHouseCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.houseCategory = action.payload;
      })
      .addCase(singleHouseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerHouseCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerHouseCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.houseCategory = action.payload;
      })
      .addCase(registerHouseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default HouseCategorySlice.reducer;
